module.exports = __webpack_public_path__ + "img/KIA.d7642f1.jpg";